import script from "./Withdrawal.vue?vue&type=script&setup=true&lang=js"
export * from "./Withdrawal.vue?vue&type=script&setup=true&lang=js"

import "./Withdrawal.vue?vue&type=style&index=0&id=0718a9d0&lang=css"

const __exports__ = script;

export default __exports__